<ng-container *ngIf="availableTypes$ | async as availableTypes">
    <bs-system-bet-type-container
        *ngFor="let typeInfo of availableTypes"
        [systemTypeInfo]="typeInfo"
        [isEpcotEnabled]="isEpcotEnabled"
        [oddsDisplayFormat]="oddsDisplayFormat"></bs-system-bet-type-container>
</ng-container>
